import type { MetaShortDTO } from 'shared/types/api'
import { fetchPageData } from 'shared/store/actions'
import endpoints from 'shared/store/endpoints'

type ActionTimelinePageDataResponse = {
    type: 'PAGE_DATA_TIMELINE_RESPONSE',
    data: {
        metaData: MetaShortDTO
    }
}

const fetchTimelinePageData = () =>
    fetchPageData(endpoints.pages.timeline, 'PAGE_DATA_TIMELINE_RESPONSE')

export { fetchTimelinePageData }

export type Action = ActionTimelinePageDataResponse
